import posthog from 'posthog-js';

export type RequestOutcome =
  | 'success'
  | 'client_error'
  | 'server_error'
  | 'network_error'
  | 'timeout'
  | 'cancelled';

export function metricsEnvironment(hostname: string): 'production' | null {
  if (hostname === 'botspot.trade' || hostname === 'www.botspot.trade') return 'production';
  return null;
}

const METHODS = new Set(['GET', 'POST', 'PUT', 'PATCH', 'DELETE', 'HEAD', 'OPTIONS']);

export function recordApiRequest(
  method: string,
  outcome: RequestOutcome,
  durationMs: number,
): void {
  // Unknown/local hosts never send application metrics to the production project.
  if (!metricsEnvironment(window.location.hostname)) return;
  try {
    if (!posthog.config?.token) return;
    if (
      posthog.config.metrics?.serviceName !== 'botspot-web' ||
      posthog.config.metrics?.environment !== 'production'
    ) {
      posthog.set_config({ metrics: { serviceName: 'botspot-web', environment: 'production' } });
    }
    const attributes = {
      method: METHODS.has(method.toUpperCase()) ? method.toUpperCase() : 'OTHER',
      outcome,
    };
    posthog.metrics.count('botspot.web.api.requests', 1, { attributes });
    posthog.metrics.histogram('botspot.web.api.duration', Math.max(0, durationMs), {
      unit: 'ms',
      attributes,
    });
  } catch {
    // Optional telemetry must never change the request's result or error.
  }
}
